import React from "react"
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle"
import { useColors } from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import Tag from "~components/shared/todo-lib-react-components/tag"

export default function OutfitterLicensedPill() {
    const styleProps = useStyleProps()

    return (
        <Tag style={styleProps.tag} leftIcon={faCheckCircle}>
            {COPY.LICENSED_OUTFITTER}
        </Tag>
    )
}

function useStyleProps() {
    const colors = useColors()
    const tag = {
        backgroundColor: colors.success,
        border: "none",
        color: colors.text,
        width: "fit-content",
        padding: "0.3rem",
    }

    return { tag }
}
